export default "__VITE_ASSET__kF$l$Q_6__"